﻿'use strict';

angular.module('ntmApp').factory('DragActivitySequence', ['DraggingObject', 'DailyPlanService', 'FlashService', 'Utils', 'WatchDndTargetsService',
    function (DraggingObject, DailyPlanService, FlashService, Utils, WatchDndTargetsService) {

        function DragActivitySequence(context) {

            var self = this;

            self.startDragging = function (activity) {
                self.DraggingObject.setDraggingObject(activity);
            };

            self.drag = function (sourceActivity, group) {

                var targetActivity = group.items.firstOrDefault(function (item) {
                    return item.dndTarget && item.dndTarget.length > 0;
                });

                if (targetActivity) {

                    targetActivity.dndTarget = [];

                    if (targetActivity.activitySequence !== sourceActivity.activitySequence) {

                        var request = context.getViewModeSelectedDateAndRoomInfo();

                        request.dragActivities = [
                              {
                                  id: sourceActivity.scheduleId,
                                  value: targetActivity.activitySequence
                              },
                              {
                                  id: targetActivity.scheduleId,
                                  value: sourceActivity.activitySequence
                              },
                        ];


                        var loadingModal = FlashService.Loading();

                        DailyPlanService.ChangeSequence(request).then(function (result) {

                            loadingModal.dismiss();

                            if (result.success) {
                                FlashService.Success(result.data.message);
                                Utils.Swap(targetActivity, sourceActivity, 'activitySequence');
                            }
                        });
                    }
                }
            };

            self.endDragging = function () {
                if (!WatchDndTargetsService.DKeyPressed) {
                    self.DraggingObject.releaseDraggingObject();
                }
            };

            self.isSourceActivity = function (activity) {
                return self.DraggingObject.isDragging(activity);
            };

            self.isTargetActivity = function (activity, group) {

                var draggingActivity = self.DraggingObject.getDraggingObject();

                if (draggingActivity) {
                    return draggingActivity.dndType === group.name && !self.isSourceActivity(activity);
                }

                return false;
            };

            function initialize() {
                self.DraggingObject = new DraggingObject();
            }

            initialize();

        }

        return (DragActivitySequence);

    }]);